import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  title: () => i18n.t(i18nKeys.fastPay__title),
  description: () => i18n.t(i18nKeys.fastPay__description),
  fastPayModal__primaryAction: () =>
    i18n.t(i18nKeys.fastPay__fastPayModal__primaryAction),
  fastPay__fastPayModal__line1: () =>
    i18n.t(i18nKeys.fastPay__fastPayModal__line1),
  fastPay__fastPayModal__line2: () =>
    i18n.t(i18nKeys.fastPay__fastPayModal__line2),
  fastPay__fastPayModal__line3: () =>
    i18n.t(i18nKeys.fastPay__fastPayModal__line3),
  fastPay__fastPayModal__line4: () =>
    i18n.t(i18nKeys.fastPay__fastPayModal__line4),
  fastPayInfo__accessibilityLabel: () =>
    i18n.t(i18nKeys.fastPay__fastPayInfo__accessibilityLabel),
}
